<!-- Modal -->
<div *ngIf="teklif !== null" class="modal modal-blur fade" id="teklif-fiyat-gecmisi-modal" tabindex="-1" role="dialog"
  aria-hidden="true">
  <div class="modal-dialog modal-full-width modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Teklif Fiyat Geçmişi</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="alert alert-important alert-warning alert-dismissible mr-2" role="alert">
          <div class="d-flex">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <div>
              <strong>Teklif Veren Firma: </strong>{{teklif?.cari?.cariKodu}} - {{teklif?.cari?.firmaUnvani}}
            </div>
          </div>
          <!-- <a class="btn-close btn-close-white" data-bs-dismiss="alert" aria-label="close"></a> -->
        </div>

        <div class="table-responsive">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th class="w-1">Stok Kodu</th>
                <th>Stok Adı</th>
                <th>Ölçü Birimi</th>
                <th>Sarf Yeri</th>
                <th>Talep Edilen Miktar</th>
                <th>Firma Teklifi (Birim Fiyatı)</th>
                <th>Para Birimi</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let k of teklif?.teklifKalemler;let i=index;">
                <tr>
                  <td><span class="text-muted">{{k?.talepKalem?.stokKodu}}</span></td>
                  <td>{{k?.talepKalem?.stokAdi}}</td>
                  <td>{{k?.talepKalem?.olcuBirimi}}</td>
                  <td>{{k?.talepKalem?.sarfYeri?.aciklama}}</td>
                  <td>{{k?.talepKalem.talepEdilen}}</td>
                  <td>{{k?.tutar}}</td>
                  <td>{{k?.paraBirimi?.aciklama}}</td>
                </tr>
                <ng-container *ngIf="k?.teklifFiyatDegisiklikler.length > 0">
                  <tr *ngFor="let d of k?.teklifFiyatDegisiklikler" class="bg-info">
                    <td colspan="3" class="text-center text-white"><strong>ESKİ FİYAT BİLGİLERİ (TARİH - DEĞİŞİKLİK YAPAN KULLANICI - FİYAT)</strong></td>
                    <td class="text-white">{{d.olusturmaTarihi | date: 'dd.MM.yyyy HH:mm'}}</td>
                    <td class="text-white">{{d.kullanici?.adSoyad}}</td>
                    <td class="text-white">{{d.fiyat}}</td>
                    <td class="text-white">{{d.paraBirimi?.aciklama}}</td>
                  </tr>
                </ng-container>
              </ng-container>

              <!-- <tr *ngFor="let k of teklif?.teklifKalemler;let i=index;">
                <td><span class="text-muted">{{k?.talepKalem?.stokKodu}}</span></td>
                <td>{{k?.talepKalem?.stokAdi}}</td>
                <td>{{k?.talepKalem?.olcuBirimi}}</td>
                <td>{{k?.talepKalem?.sarfYeri?.aciklama}}</td>
                <td>{{k?.talepKalem.talepEdilen}}</td>
                <td>{{k?.tutar}}</td>
                <td>{{k?.paraBirimi?.aciklama}}</td>
              </tr> -->
            </tbody>
          </table>
        </div>
        
        <div class="card-footer text-right">
          <b>Teklif Toplamı:</b> {{totalTutarText}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->